import CommitteeCard from "./CommitteeCard";
import axios from "axios";
import { API_BASE_URL } from "../../../apiConfig";
import { useEffect, useState } from "react";

function Committee() {
    const [committees, setCommittees] = useState('')
    useEffect(() => {
        const language = document.getElementById('language').value;
        axios.get(`${API_BASE_URL}/committees`).then((res) => {
            const data = res.data.committees;
            const committees = data.map((item) => {
                let key = 1;
                return <CommitteeCard data={item} key={key++} />
            });
            setCommittees(committees)
        });

    }, []);
    const styles = {
        cardWrapper: {
            display: 'grid',
            padding: '0 6rem',
            rowGap: '2rem',
            paddingBottom: '2rem'
        },
    };
    return (
        <div id="Committee" className='tabcontent' style={{ display: 'none' }}>
            <div id="committees-wrapper" style={styles.cardWrapper}>
                {committees}
            </div>
        </div>
    );
}

export default Committee;